<script>
import TimePicker from '@/components/common/pickers/TimePicker.vue'

export default {
  components: {
    TimePicker
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  data: vm => ({
    menu: false,
    allowedDays: [1, 2, 3, 4, 5],
    dayLabel: vm.$t('component.documentValidation.scheduleCustom.day')
  }),
  computed: {
    today() {
      return new Date().toISOString().substr(0, 10)
    },
    dateFormatted() {
      return this.value.date
        ? this.momentDate(this.value.date).format('D.M.YYYY')
        : ''
    }
  },
  created() {
    // force parents to update model-values
    this.$emit('input', this.value)
  },
  methods: {
    allowedDates(val) {
      return this.allowedDays.includes(this.momentDate(val).day())
    },
    handleChange() {
      this.menu = false
      this.$emit('input', this.value)
    }
  }
}
</script>
<template>
  <v-row>
    <v-col cols="12" lg="6">
      <v-menu v-model="menu" :close-on-content-click="false" max-width="290">
        <template #activator="{ on, attrs }">
          <v-text-field
            v-bind="attrs"
            :value="dateFormatted"
            :label="dayLabel"
            :disabled="disabled"
            :outlined="!disabled"
            :readonly="!disabled"
            hide-details
            dense
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="value.date"
          locale="de-DE"
          :min="today"
          :first-day-of-week="1"
          :allowed-dates="allowedDates"
          :disabled="disabled"
          @change="handleChange"
        ></v-date-picker>
      </v-menu>
    </v-col>
    <v-col cols="12" lg="6">
      <TimePicker
        v-model="value.time"
        :date="value.date"
        :disabled="disabled"
        @input="handleChange"
      />
    </v-col>
  </v-row>
</template>
